<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Список шаблонов системы:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat>
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="total"
              :loading="loading"
              class="elevation-1"
              :rows-per-page-items="[10,15,100]"
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">
                    {{props.item.name}}
                </td>
                <td class="justify-center">
                  <a v-if="props.item.document !== null " :href="props.item.document" target="_blank" rel="noopener noreferrer">Ссылка на файл</a>
                </td>
                <td class="justify-center">{{findNameObj('file_fileds',props.item.field)}}</td>

                <td class="justify-center " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <DocTemplate @addItem="addItem"
                    @ended="closedForm"
                    @refreshItem="refreshItem"
                    v-bind="selected"
                    v-if="opened_form"
      >
      </DocTemplate>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
    import DocTemplate  from "../forms/DocTemplate"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "ListDocTemplate",
        components: {DocTemplate},
        mixins: [UserDataMixin],

        data () {
            return {
                URL_LIST: urls.getUrl('admin|core|models|document_template-list', 'list'),
                URL_DELETE: urls.getUrl('admin|core|models|document_template-detail', 'destroy'),
                selectors:{
                    file_fileds: [],
                },
                total: 0,
                items: [],
                loading: true,
                pagination: {},
                headers: [
                    {
                        text: 'Наименование', sortable: false, align: 'justify-center',
                        value: 'name',
                        // class: 'headline'
                    },
                    {
                        text: 'Ссылка', sortable: false, align: 'justify-center',
                    },
                    {
                        text: 'Относится к полю', sortable: false, align: 'justify-center',
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ]
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getItems()
                },
                deep: true
            }
        },
        mounted () {
            this.getItems()
        },
        created() {
            let url = process.env.VUE_APP_API_HOST +"council/admin/core/selectors/file_fields/"
            let sys = true
            makeGetRequest(url).then(resp => {
                if (!resp.ok) {
                    sys = false
                }
                return resp.json()
            }) .then(json => {
                this.selectors.file_fileds = json
            })
        },
        methods: {
            findNameObj(edit,id){
                let obj = this.selectors[edit].find(item => item.value === id);
                if (obj !== undefined) {
                    return obj.text
                }else{
                    return ""
                }
            },
            addItem(){
                this.closedForm()
                this.getItems();
            },
            getItems () {
                this.loading = true
                let url =  urls.getUrl('admin|core|models|document_template-list', 'list')+"?page="+this.pagination.page +"&page_size="+ this.pagination.rowsPerPage
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                })
            },
        }
    }


</script>
<style scoped>

</style>
